export default "/images/5852c96928ec71772b01dca8d7922295.avif";